import Row from '@amzn/meridian/row';
import React, { useEffect } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { ProtectedRoute } from '../components/blocks';
import { SiteMapPage } from '../types';
import { Debug } from '../utils/debug';
import { SiteMapRouterContext, SiteMapRouterContextType } from '../utils/SiteMapRouter';

const Routes = () => {
    return (
        <SiteMapRouterContext.Consumer>
            {(siteMapContext: SiteMapRouterContextType) => (
                <Switch>
                    {siteMapContext.pages.map((page: any) => {
                        return (
                            <ProtectedRoute exact={true} path={page.path} resource={page.id} key={page.id}>
                                {(props) => {
                                    let component: any;
                                    if (React.isValidElement(page.component)) {
                                        component = page.component;
                                    } else {
                                        component = React.createElement(page.component);
                                    }
                                    return (
                                        <Row widths={['fill']} alignmentVertical={'top'}>
                                            {React.createElement(() => {
                                                // This useEffect usage is valid, since we are inside of an
                                                // anonymous component.
                                                // FIXME: replace with sitemap rules -- 3/20/22
                                                /* eslint-disable-next-line react-hooks/rules-of-hooks */
                                                useEffect(() => {
                                                    Debug.assertExists(props.match);
                                                    siteMapContext.setCurrentPage(page, props.match);
                                                }, []);
                                                return null;
                                            })}
                                            {component}
                                        </Row>
                                    );
                                }}
                            </ProtectedRoute>
                        );
                    })}
                    <Redirect to={siteMapContext.getPath(SiteMapPage.pageNotFound, {})}>{null}</Redirect>
                </Switch>
            )}
        </SiteMapRouterContext.Consumer>
    );
};

export { Routes };
